import Body from '../Body/Body';

export interface ProjectQuoteProps {
  author?: string;
  children: string;
}
const ProjectQuote: React.FC<ProjectQuoteProps> = ({ author, children }) => {
  return (
    <div className="flex flex-col gap-32 laptop:px-256">
      <p className="font-respira text-respira-sm tablet:text-respira-md">
        {`"${children}"`}
      </p>
      {author && (
        <Body>
          <>– {author} </>
        </Body>
      )}
    </div>
  );
};

export default ProjectQuote;
